import React from 'react';
import { Citation } from './Citation';
import { Data } from './Data';
import { DonateWithPhoto, DonateSimple } from './Donate';
import { Paragraph } from './Paragraph';
import { RedirectionBox } from './RedirectionBox';
import { Newsletter } from './Newsletter';

export interface CommonComponentContent {
  color: string,
  description: string,
  secondaryColor: string,
  title: string,
  name: string,
  photo: string,
  text: string,
  citedName: string,
  role: string,
  dataPairs: Array<{ data: string, text: string }>,
  cta: string,
  url: string,
  newWindow: boolean,
  component: string,
}

export const CommonComponent: React.FC<CommonComponentContent> = (props) => {
  if (props.name === 'paragraph') {
    return (
      <Paragraph
        title={props.title}
        text={props.text}
      />
    );
  }

  if (props.name === 'citation') {
    return (
      <Citation
        photo={props.photo}
        name={props.citedName}
        role={props.role}
        text={props.text}
      />
    );
  }

  if (props.name === 'dataList') {
    return (
      <Data
        color={props.color}
        secondaryColor={props.secondaryColor}
        datas={props.dataPairs}
      />
    );
  }

  if (props.name === 'simpleDonation') {
    return <DonateSimple cta={props.cta} text={props.text} />;
  }

  if (props.name === 'donationWithPhoto') {
    return <DonateWithPhoto cta={props.cta} text={props.text} image={props.photo} color={props.color} />;
  }

  if (props.name === 'redirectionBox') {
    return <RedirectionBox cta={props.cta} title={props.title} description={props.description} url={props.url} newWindow={props.newWindow} />;
  }

  if (props.name === 'staticComponent') {
    switch (props?.component) {
      case 'newsletter':
        return <Newsletter />;
      default:
        // nothing
    }
  }

  console.warn('Unsupported component name?', props);
  return null;
};
